if (!customElements.get("tj-hotsale-slider")) {
  class TjHotsaleSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector("[data-tj-viewport]");
      this.track = this.querySelector("[data-tj-track]");
      this.prev = this.querySelector("[data-tj-prev]");
      this.next = this.querySelector("[data-tj-next]");
      if (!this.viewport || !this.track) return;

      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.gap = Number(this.dataset.gap) || 30;
      this.slideW = 0;
      this.maxIndex = 0;
      this.drag = { tracking: false, dragging: false, startX: 0, lastX: 0, pointerId: null };

      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.prev?.addEventListener("click", this.onPrev);
      this.next?.addEventListener("click", this.onNext);

      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.viewport.addEventListener("pointerdown", this.onPointerDown);
      this.viewport.addEventListener("pointermove", this.onPointerMove);
      this.viewport.addEventListener("pointerup", this.onPointerUp);
      this.viewport.addEventListener("pointercancel", this.onPointerUp);

      this.track.addEventListener("click", (event) => {
        if (this.ignoreClick) {
          event.preventDefault();
          event.stopPropagation();
          this.ignoreClick = false;
        }
      }, true);

      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.viewport);
      this.layout();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener("click", this.onPrev);
      this.next?.removeEventListener("click", this.onNext);
      this.viewport?.removeEventListener("pointerdown", this.onPointerDown);
      this.viewport?.removeEventListener("pointermove", this.onPointerMove);
      this.viewport?.removeEventListener("pointerup", this.onPointerUp);
      this.viewport?.removeEventListener("pointercancel", this.onPointerUp);
      this.resizeObserver?.disconnect();
    }

    canSlide() {
      return this.slides.length > this.perView();
    }

    perView() {
      const width = this.viewport.clientWidth;
      if (width < 750) return 1;
      if (width < 1100) return 2;
      return 4;
    }

    layout() {
      const perView = this.perView();
      const viewportWidth = this.viewport.clientWidth;
      const slideWidth = (viewportWidth - this.gap * (perView - 1)) / perView;

      this.slideW = slideWidth;
      this.maxIndex = Math.max(0, this.slides.length - perView);
      this.index = Math.min(this.index, this.maxIndex);

      this.slides.forEach((slide) => {
        slide.style.flex = `0 0 ${slideWidth}px`;
        slide.style.width = `${slideWidth}px`;
        slide.style.maxWidth = `${slideWidth}px`;
      });

      this.track.style.gap = `${this.gap}px`;
      this.update(false);
    }

    go(direction) {
      if (!this.canSlide()) return;

      this.index += direction;
      if (this.index < 0) this.index = this.maxIndex;
      else if (this.index > this.maxIndex) this.index = 0;
      this.update(true);
    }

    offset() {
      return this.index * (this.slideW + this.gap);
    }

    update(animate) {
      this.track.style.transition = animate === false ? "none" : "transform 0.45s ease";
      this.track.style.transform = `translate3d(-${this.offset()}px, 0, 0)`;

      const canSlide = this.canSlide();
      if (this.prev) this.prev.disabled = !canSlide;
      if (this.next) this.next.disabled = !canSlide;
    }

    handlePointerDown(event) {
      if (!this.canSlide()) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      this.drag.tracking = true;
      this.drag.dragging = false;
      this.drag.startX = event.clientX;
      this.drag.lastX = event.clientX;
      this.drag.pointerId = event.pointerId;
    }

    handlePointerMove(event) {
      if (!this.drag.tracking) return;
      this.drag.lastX = event.clientX;
      const delta = event.clientX - this.drag.startX;

      if (!this.drag.dragging) {
        if (Math.abs(delta) < 12) return;
        this.drag.dragging = true;
        this.ignoreClick = true;
        this.track.style.transition = "none";
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      this.track.style.transform = `translate3d(${delta - this.offset()}px, 0, 0)`;
    }

    handlePointerUp(event) {
      if (!this.drag.tracking) return;

      const wasDragging = this.drag.dragging;
      const delta = this.drag.lastX - this.drag.startX;
      const pointerId = event.pointerId ?? this.drag.pointerId;

      this.drag.tracking = false;
      this.drag.dragging = false;
      this.drag.pointerId = null;

      if (pointerId != null && this.viewport.hasPointerCapture?.(pointerId)) {
        this.viewport.releasePointerCapture(pointerId);
      }

      if (!wasDragging) return;

      if (Math.abs(delta) > 50) this.go(delta < 0 ? 1 : -1);
      else this.update(true);
    }
  }

  customElements.define("tj-hotsale-slider", TjHotsaleSlider);
}
